import { Tooltip, Typography } from "@mui/material";
import { HelpOutline } from "@mui/icons-material";
import { useEffect } from "react";
import ModelSelector from "../../components/ModelSelector";
import PopOutTextInput from "../../components/PopOutTextInput";
import { VariableField } from "../../components/PopOutTextDialog";

export default ({
  actionParameters,
  setActionParameters,
  currentPlan,
  headers,
  existingRecord,
  setValidForm,
  getToken,
  companyId,
}: {
  actionParameters: any;
  setActionParameters: (p: any) => void;
  currentPlan: string;
  headers: Array<any>;
  existingRecord: boolean;
  setValidForm: (b: boolean) => void;
  getToken?: () => Promise<string>;
  companyId?: string;
}) => {
  useEffect(() => {
    setValidForm(actionParameters.prompt && actionParameters.model);
  }, [actionParameters]);

  // Build variable fields from headers
  const variableFields: VariableField[] = [
    { key: "Company Description", label: "Company Description" },
    { key: "Full Record", label: "Full Record" },
    ...headers.map((header) => ({
      key: header.field,
      label: header.field,
    })),
  ];

  return (
    <div>
      <div style={{ marginTop: "16px" }}>
        <Typography
          variant="subtitle1"
          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
        >
          Model
          <Tooltip title="GPT-4o and Claude models offer the best quality but cost more. GPT-4o-mini and Claude Haiku are faster and cheaper for simpler tasks like formatting or short text generation.">
            <HelpOutline
              sx={{ fontSize: 16, color: "text.secondary", cursor: "help" }}
            />
          </Tooltip>
        </Typography>
        <Typography variant="body2">
          Choose your AI model. Some models are more expensive but provide
          higher quality results.
        </Typography>
        <ModelSelector
          currentPlan={currentPlan}
          onChange={(e) =>
            setActionParameters({ ...actionParameters, model: e.target.value })
          }
          value={actionParameters.model}
          tools
        />
      </div>

      <div style={{ marginTop: "24px" }}>
        <Typography
          variant="subtitle1"
          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
        >
          AI Prompt
          <Tooltip title="Write clear instructions for what text to generate. Use {{Column Name}} to insert row data. Specify length, tone, and format. The output will be saved to a new column in your list.">
            <HelpOutline
              sx={{ fontSize: 16, color: "text.secondary", cursor: "help" }}
            />
          </Tooltip>
        </Typography>
        <Typography variant="body2">
          Write a prompt that describes what text you want the AI to generate.
          Use column references to include data from the current row.
        </Typography>
        <PopOutTextInput
          fullWidth
          multiline
          rows={8}
          placeholder="Write a personalized cold email introduction for {{First Name}} at {{Company Name}} based on their role as {{Position Title}}. Keep it under 100 words and mention their {{Industry}}."
          variant="outlined"
          value={actionParameters.prompt || ""}
          onChange={(value) =>
            setActionParameters({ ...actionParameters, prompt: value })
          }
          sx={{ marginTop: "8px" }}
          dialogTitle="AI Prompt"
          dialogDescription="Write a prompt that describes what text you want the AI to generate."
          popOutRows={20}
          variableFields={variableFields}
          enableSlashTrigger
          getToken={getToken}
          companyId={companyId}
          aiContext="AI text generation prompt for a smart list action"
        />
      </div>
    </div>
  );
};
